import type { ReactNode } from 'react';

import { motion, useReducedMotion } from 'framer-motion';

import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Tooltip';
import { Flex } from 'components/layout';

import DrumkitLogo from '../../../../assets/drumkit-logo.png';

type HeaderProps = {
  bubble: ReactNode;
  existingLoads: ReactNode;
  // Thread check bubbles and the "Ask Kit to check this thread" chips, under the bubble.
  threadCheck?: ReactNode;
  isProcessing?: boolean;
};

const DRUM_ROLL = { rotate: [0, -12, 10, -6, 0] };

// Kit header (logo + title + message bubble + thread-loads callout)
export function Header({
  bubble,
  existingLoads,
  threadCheck = null,
  isProcessing = false,
}: HeaderProps) {
  const shouldReduceMotion = useReducedMotion();

  return (
    <Flex align='start' gap='sm' className='w-full relative'>
      <div className='absolute -top-1 -left-2'>
        <Tooltip delayDuration={10}>
          <TooltipTrigger>
            <Flex direction='col' align='center' gap='xs'>
              <motion.div
                animate={
                  isProcessing && !shouldReduceMotion ? DRUM_ROLL : undefined
                }
                transition={{
                  duration: 0.6,
                  repeat: Infinity,
                  ease: 'easeInOut',
                }}
              >
                <Flex
                  align='center'
                  justify='center'
                  className='h-8 w-8 shrink-0 rounded-full border border-brand bg-brand-100'
                >
                  <img
                    src={DrumkitLogo}
                    alt=''
                    className='h-4 w-4 object-contain'
                    aria-hidden
                  />
                </Flex>
              </motion.div>
            </Flex>
          </TooltipTrigger>
          <TooltipContent side='right' className='max-w-[250px]'>
            Kit, your Drumkit AI Agent!
          </TooltipContent>
        </Tooltip>
      </div>
      <Flex
        direction='col'
        gap='xs'
        align='stretch'
        className='min-w-0 w-full flex-1 pl-2'
      >
        {bubble}
        {existingLoads}
        {threadCheck}
      </Flex>
    </Flex>
  );
}
